import { render } from "./multi-whitelabel.vue?vue&type=template&id=56db8fb1&ts=true"
import script from "./multi-whitelabel.ts?vue&type=script&lang=ts"
export * from "./multi-whitelabel.ts?vue&type=script&lang=ts"

import "./multi-whitelabel.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__